import { useEffect } from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { Spinner, StatusBanner } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import {
  useMobileHealthCardErrorMessage,
  useMobileHealthCardLoading,
  clearMobileHealthCardError,
  resetMobileHealthCardErrorStore,
} from 'masonry/stores/mobile-health-card-error.store';

type MobileHealthCardErrorNode = MasonryEngineNode<
  'mobileHealthCardError',
  // eslint-disable-next-line @typescript-eslint/ban-types
  {}
>;

type MobileHealthCardErrorRendererProps =
  MasonryEngineNodeRendererProps<MobileHealthCardErrorNode>;

export const MobileHealthCardErrorRenderer = ({
  rootElementRef,
  engineClassName,
  locatorId,
}: MobileHealthCardErrorRendererProps) => {
  const { formatMessage } = useIntl();
  const message = useMobileHealthCardErrorMessage();
  const isLoading = useMobileHealthCardLoading();

  useEffect(
    () => () => {
      resetMobileHealthCardErrorStore();
    },
    [],
  );

  if (isLoading) {
    return (
      <div
        ref={rootElementRef}
        className={engineClassName}
        data-testid={locatorId}
      >
        <Spinner
          loading
          loadingText={formatMessage({
            id: 'STR_MOBILE_HEALTH_CARD_LINKOUT_LOADING',
          })}
        />
      </div>
    );
  }

  if (!message) return null;

  return (
    <div
      ref={rootElementRef}
      className={engineClassName}
      data-testid={locatorId}
    >
      <StatusBanner
        status="error"
        title={message}
        onDismissClick={clearMobileHealthCardError}
      />
    </div>
  );
};
